import axios from "axios";
import { getServerApiUrl } from "shared";

const API_URL = `${getServerApiUrl()}/customerarea/offers`;

const handle = async (params) => {
  const response = await axios.post(API_URL + "/handle", params);
  console.info(response);
  return { response };
};

const offersService = {
  handle,
};

export default offersService;
